import { ESstrings, CommonStrings } from '../localisation/strings.en';

export const getShowOkValue = (title: string): boolean => {
    return !(title === ESstrings.Session ||
        title === ESstrings.PERMISSION ||
        title === ESstrings.Success ||
        title === ESstrings.Error)
};

export const getPromiseErrorPopup = (
    showDialog: (str: boolean) => void,
    setMessage: (str: string) => void,
    setTitle: (str: string) => void,
    dataError: string
): void => {
    showDialog(true);
    setMessage(dataError && dataError?.includes('401') ? CommonStrings.SessionMessage : CommonStrings.WentWrong);
    setTitle(dataError && dataError?.includes('401') ? ESstrings.Session : ESstrings.Error);
};

export const getPopupMessageData = (
    showDialog: (str: boolean) => void,
    setMessage: (str: string) => void,
    setTitle: (str: string) => void,
    message: string,
    title: string
): void => {
    showDialog(true);
    setMessage(message);
    setTitle(title);
};
